import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";

import styles from './ModalPrivacyPolicy.module.scss';
import MainButtonWithBackground from "../UI/MainButtonWithBackground/MainButtonWithBackground";
import CustomCheckbox from "../UI/CustomCheckbox/CustomCheckbox";
import {MAIN_ROUTES} from "../../routing/main_routes";
import {offerService} from "../../services/offer.service";
import toast from "react-hot-toast";

const ModalPrivacyPolicy = ({type, cleaning_request, application, handleClose}) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isChecked, setIsChecked] = useState(false);

  const {state} = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleCheckboxChange = () => {
    setIsChecked(prev => !prev);
  }

  const handleCreateOffer = async () => {
    try {
      const offer = {
        application: state?.application?.id,
        cleaner_request: state?.cleaning_request?.pk,
        response_url: `${process.env.REACT_APP_URL}order-details/${state?.cleaning_request?.pk}`,
        server_url: process.env.REACT_APP_API_URL,
      }

      const {status, data} = await offerService.create(offer);
      if (status === 201) {
        window.open(data.response.checkout_url);
        setTimeout(() => {
          navigate(`${MAIN_ROUTES.ORDER_DETAILS}/${state?.cleaning_request?.pk}`);
        }, 3000);
      }
    } catch (error) {
      console.log(error)
      if (error?.response?.data?.cleaner_request?.[0] === "offer with this cleaner request already exists.") {
        toast.error("Ви вже прийняли 1 людину! Якщо у вас виникли питання, будь ласка, зв'яжіться з нашою службою підтримки.", {id: "create-offer"});
      } else {
        toast.error(`На жаль, заявку не було подано. ${JSON.stringify(error?.response?.data)}. Спробуйте, будь ласка, ще раз!`, {id: "create-offer"});
      }
    }
  }

  const handleNavigate = async () => {
    if (type === 'customer') {
      await handleCreateOffer();
    }
  }

  return (
    <div className={styles.modalPrivacyPolicy}>
      <div className={styles.modalPrivacyPolicy_content}>
        <div className={styles.modalPrivacyPolicy_content_titleContainer}>
          <h2>Політика конфідеційності</h2>
          <p>Правила, якими ми слідуємо при роботі з персональними даними користувачів сайту. Ми поважаємо
            вашу конфіденційність і дана інформація пояснює, що відбувається з вашими даними, які ми від вас
            отримуємо, коли ви використовуєте Сайт або берете участь у Дні конфіденційності.</p>
        </div>

        <div className={styles.modalPrivacyPolicy_content_block}>
          <h3 className={styles.subtitle}>1. ВИЗНАЧЕННЯ ТЕРМІНІВ</h3>
          <div>
            <p className={styles.description}>1.1 У цій Політиці конфіденційності використовуються такі терміни:</p>
            <p className={styles.description}>1.1.1. «Адміністрація цього сайту (далі – Адміністрація сайту)» –
              уповноважені співробітники на управління сайтом, що діють від імені клінінгової компанії «Санде", які
              організовують та здійснює обробку персональних даних, а також визначає цілі обробки персональних даних,
              склад персональних даних, що підлягають обробці , дії чи операції, що здійснюються з персональними
              даними.</p>
            <p className={styles.description}>1.1.2. «Персональні дані» - будь-яка інформація, що відноситься до прямо
              чи опосередковано визначеної чи визначеної фізичної особи (суб'єкта персональних даних).</p>
            <p className={styles.description}>1.1.3. «Обробка персональних даних» - будь-яка дія (операція) або
              сукупність дій (операцій), що здійснюються з використанням засобів автоматизації або без використання
              таких засобів з персональними даними, включаючи збирання, записування, систематизацію, накопичення,
              зберігання, уточнення (оновлення, зміну), вилучення, використання, передачу (поширення, надання, доступ),
              знеособлення, блокування, видалення, знищення персональних даних.</p>
            <p className={styles.description}>1.1.4. «Конфіденційність персональних даних» - обов'язкова для дотримання
              Адміністратором або іншою особою, яка отримала доступ до персональних даних, вимога не допускати їх
              розповсюдження без згоди суб'єкта персональних даних або наявності іншої законної підстави.</p>
            <p className={styles.description}>1.1.5. «Користувач сайту Kova App» – особа, яка має доступ до Сайту, за
              допомогою мережі Інтернет та використовує Сайт.</p>
            <p className={styles.description}>1.1.6. "Cookies" - невеликий фрагмент даних, надісланий веб-сервером і
              зберігається на комп'ютері користувача, який веб-клієнт або веб-браузер щоразу пересилає веб-серверу в
              HTTP-запиті при спробі відкрити сторінку відповідного сайту.</p>
            <p className={styles.description}>1.1.7. IP-адреса — унікальна мережна адреса вузла в комп'ютерній мережі,
              побудованій за протоколом IP.</p>
          </div>
        </div>

        <div className={styles.modalPrivacyPolicy_content_block}>
          <h3 className={styles.subtitle}>2. ЗАГАЛЬНІ ПОЛОЖЕННЯ</h3>
          <div>
            <p className={styles.description}>
              2.1. Використання Користувачем сайту з означає згоду з цією Політикою конфіденційності та умовами обробки
              персональних даних Користувача.</p>
            <p className={styles.description}>2.2. У разі незгоди з умовами Політики конфіденційності Користувач повинен
              припинити використання веб-сайту.</p>
            <p className={styles.description}>2.3.Ця Політика конфіденційності застосовується лише до сайту.
              Адміністрація сайту не контролює та не несе відповідальності за сайти третіх осіб, на які Користувач може
              перейти за посиланнями, доступними на сайті.</p>
            <p className={styles.description}>2.4. Адміністрація сайту не перевіряє достовірність персональних даних,
              які надає Користувач сайту.</p>
          </div>
        </div>

        <div className={styles.modalPrivacyPolicy_content_block}>
          <h3 className={styles.subtitle}>3. ПРЕДМЕТ ПОЛІТИКИ КОНФІДЕНЦІЙНОСТІ</h3>
          <div>
            <p className={styles.description}>3.1. Ця Політика конфіденційності встановлює зобов'язання Адміністрації
              сайту щодо нерозголошення та забезпечення режиму захисту конфіденційності персональних даних, які
              Користувач надає на запит Адміністрації сайту при реєстрації на сайті.</p>
            <p className={styles.description}>3.1. Ця Політика конфіденційності встановлює зобов'язання Адміністрації
              сайту щодо нерозголошення та забезпечення режиму захисту конфіденційності персональних даних, які
              Користувач надає на запит Адміністрації сайту при реєстрації на сайті.</p>
            <ul>
              <li> ПІБ Користувача;</li>
              <li>контактний телефон Користувача;</li>
              <li> адресу електронної пошти (e-mail);</li>
              <li>місце надання послуг.</li>
            </ul>
            <p className={styles.description}>3.3. Адміністрація сайту захищає Дані, які автоматично передаються в
              процесі перегляду рекламних блоків та при відвідуванні сторінок, на яких встановлено статистичний скрипт
              системи ("піксель"):</p>
            <ul>
              <li> IP-адреса;</li>
              <li> інформація з cookies;</li>
              <li> інформація про браузер (або іншу програму, яка здійснює доступ до показу реклами);</li>
              <li> час доступу;</li>
              <li> адресу сторінки, де розташований рекламний блок;</li>
              <li> реферер (адреса попередньої сторінки).</li>
            </ul>
            <p className={styles.description}>3.3.1. Відключення cookies може спричинити неможливість доступу до частин
              сайту, які потребують авторизації.</p>
            <p className={styles.description}>3.3.2. Адміністрація сайту здійснює збір статистики про IP-адреси своїх
              відвідувачів. Дана інформація використовується з метою виявлення та вирішення технічних проблем, для
              контролю законності фінансових платежів, що проводяться.</p>
            <p className={styles.description}>3.4. Будь-яка інша персональна інформація, необумовлена ​​вище (історія
              покупок, використовувані браузери та операційні системи тощо), підлягає надійному зберіганню та
              нерозповсюдженню, за винятком випадків, передбачених у п.п. 5.2. та 5.3. цієї Політики
              конфіденційності.</p>
          </div>
        </div>

        <div className={styles.modalPrivacyPolicy_content_block}>
          <h3 className={styles.subtitle}>4. ЦІЛІ ЗБОРУ ПЕРСОНАЛЬНОЇ ІНФОРМАЦІЇ КОРИСТУВАЧА</h3>
          <div>
            <p className={styles.description}>4.1. Персональні дані Користувача Адміністрація сайту може
              використовуватись з метою:</p>
            <p className={styles.description}>4.1.1. Ідентифікації Користувача, зареєстрованого на сайті, для оформлення
              послуги та (або) укладання Договору про надання клінінгових послуг із сайтом.</p>
            <p className={styles.description}>4.1.2. Надання Користувачеві доступу до персоналізованих ресурсів
              Сайту.</p>
            <p className={styles.description}>4.1.3. Встановлення з Користувачем зворотного зв'язку, включаючи
              направлення повідомлень, запитів щодо використання Сайту, надання послуг, обробка запитів та заявок від
              Користувача.</p>
            <p className={styles.description}>4.1.4. Визначення місця знаходження Користувача для забезпечення безпеки,
              запобігання шахрайству.</p>
            <p className={styles.description}>4.1.5. Підтвердження достовірності та повноти персональних даних, наданих
              Користувачем.</p>
            <p className={styles.description}>4.1.6. Створення облікового запису для здійснення покупок, якщо Користувач
              погодився на створення облікового запису.</p>
            <p className={styles.description}>4.1.7. Повідомлення Користувача Сайту про стан Замовлення.</p>
            <p className={styles.description}>4.1.8. Оброблення та отримання платежів, підтвердження податку чи
              податкових пільг Користувачем.</p>
            <p className={styles.description}>4.1.9. Надання Користувачеві ефективної клієнтської та технічної підтримки
              у разі виникнення проблем пов'язаних з використанням Сайту.</p>
            <p className={styles.description}>
              4.1.10. Надання Користувачеві з його згоди, оновлень продукції, спеціальних пропозицій, інформації про
              ціни, розсилки новин та інших відомостей від імені Сайту або від імені партнерів Сайту.</p>
            <p className={styles.description}>4.1.11. Здійснення рекламної діяльності за згодою Користувача.</p>
            <p className={styles.description}>4.1.12. Надання доступу Користувачеві на сайти або сервіси партнерів Сайту
              з метою отримання продуктів, оновлень та послуг.</p>
          </div>
        </div>

        <div className={styles.modalPrivacyPolicy_content_block}>
          <h3 className={styles.subtitle}>5. СПОСОБИ ТА ТЕРМІНИ ОБРОБКИ ПЕРСОНАЛЬНОЇ ІНФОРМАЦІЇ</h3>
          <div>
            <p className={styles.description}>5.1. Обробка персональних даних Користувача здійснюється без обмеження
              терміну будь-яким законним способом, у тому числі в інформаційних системах персональних даних з
              використанням засобів автоматизації або без використання таких засобів.</p>
            <p className={styles.description}>5.2. Користувач погоджується з тим, що Адміністрація сайту має право
              передавати персональні дані третім особам, зокрема особам які виконують замовлені послуги та/або особам
              які супутньо залучаються при виконанні послуг, виключно з метою виконання замовлення Користувача,
              оформленого на Сайті.</p>
            <p className={styles.description}>5.3. Персональні дані Користувача можуть бути передані лише на підставах
              та в порядку, встановлених законодавством України та належно ратифікованих міжнародних норм.</p>
            <p className={styles.description}>5.4. У разі втрати або розголошення персональних даних Адміністрація сайту
              інформує Користувача про втрату або розголошення персональних даних.</p>
            <p className={styles.description}>5.5. Адміністрація сайту вживає необхідних організаційних та технічних
              заходів для захисту персональної інформації Користувача від неправомірного або випадкового доступу,
              знищення, зміни, блокування, копіювання, розповсюдження, а також від інших неправомірних дій третіх
              осіб.</p>
            <p className={styles.description}>5.6. Адміністрація сайту спільно з Користувачем вживає всіх необхідних
              заходів щодо запобігання збиткам або іншим негативним наслідкам, спричиненим втратою або розголошенням
              персональних даних Користувача.</p>
          </div>
        </div>

        <div className={styles.modalPrivacyPolicy_content_block}>
          <h3 className={styles.subtitle}>6. ОБОВ'ЯЗКИ СТОРІН</h3>
          <div>
            <p className={styles.description}>6.1. Користувач зобов'язаний:</p>
            <p className={styles.description}>6.1.1. Надати інформацію про персональні дані, необхідні для користування
              Сайтом Kova App</p>
            <p className={styles.description}>6.1.2. Оновити, доповнити надану інформацію про персональні дані у разі
              зміни даної інформації.</p>
            <p className={styles.description}>6.2. Адміністрація сайту зобов'язана:</p>
            <p className={styles.description}>6.2.1. Використовувати отриману інформацію виключно для цілей, зазначених
              у п. 4 цієї Політики конфіденційності.</p>
            <p className={styles.description}>6.2.2. Забезпечити зберігання конфіденційної інформації в таємниці, не
              розголошувати без попереднього письмового дозволу Користувача, а також не здійснювати продаж, обмін,
              опублікування чи розголошення іншими можливими способами переданих персональних даних Користувача, за
              винятком п.п. 5.2. та 5.3. цієї Політики Конфіденційності.</p>
            <p className={styles.description}>6.2.3. Вживати запобіжних заходів для захисту конфіденційності
              персональних даних Користувача згідно з порядком, який зазвичай використовується для захисту такого роду
              інформації в існуючому діловому обороті.</p>
            <p className={styles.description}>6.2.4. Здійснити блокування персональних даних, що належать до
              відповідного Користувача, з моменту звернення або запиту Користувача або його законного представника або
              уповноваженого органу захисту прав суб'єктів персональних даних на період перевірки у разі виявлення
              недостовірних персональних даних або неправомірних дій.</p>
          </div>
        </div>

        <div className={styles.modalPrivacyPolicy_content_block}>
          <h3 className={styles.subtitle}>7. ВІДПОВІДАЛЬНІСТЬ СТОРІН</h3>
          <div>
            <p className={styles.description}>7.1. Адміністрація сайту, яка не виконала своїх зобов'язань, несе
              відповідальність за збитки, зазнані Користувачем у зв'язку з неправомірним використанням персональних
              даних відповідно до законодавства України, за винятком випадків, передбачених п.п. 5.2., 5.3. та 7.2. цієї
              Політики Конфіденційності.</p>
            <p className={styles.description}>7.2. У разі втрати або розголошення Конфіденційної інформації
              Адміністрація сайту не несе відповідальності, якщо ця конфіденційна інформація:</p>
            <p className={styles.description}>7.2.1. Стала громадським надбанням до її втрати чи розголошення.</p>
            <p className={styles.description}>7.2.2. Була отримана від третьої сторони до її отримання Адміністрацією
              сайту.</p>
            <p className={styles.description}>7.2.3. Була розголошена за згодою Користувача.</p>
          </div>
        </div>

        <div className={styles.modalPrivacyPolicy_content_block}>
          <h3 className={styles.subtitle}>8. ВИРІШЕННЯ СУПЕРЕЧОК</h3>
          <div>
            <p className={styles.description}>8.1. До звернення до суду з позовом щодо спорів, що виникають із відносин
              між Користувачем сайту та Адміністрацією сайту, обов'язковим є пред'явлення претензії (письмової
              пропозиції щодо добровільного врегулювання спору).</p>
            <p className={styles.description}>8.2 Одержувач претензії протягом 30 календарних днів з дня отримання
              претензії письмово повідомляє заявника претензії про результати розгляду претензії.</p>
            <p className={styles.description}>8.3. При недосягненні угоди спір буде передано на розгляд до судового
              органу відповідно до чинного законодавства України.</p>
            <p className={styles.description}>8.4. До цієї Політики конфіденційності та відносин між Користувачем та
              Адміністрацією сайту застосовується чинне законодавство України.</p>
          </div>
        </div>

        <div className={styles.modalPrivacyPolicy_content_block}>
          <h3 className={styles.subtitle}>9. ДОДАТКОВІ УМОВИ</h3>
          <div>
            <p className={styles.description}>9.1. Адміністрація сайту має право вносити зміни до цієї Політики
              конфіденційності без згоди Користувача.</p>
            <p className={styles.description}>9.2. Нова Політика конфіденційності набирає чинності з моменту її
              розміщення на Сайті, якщо інше не передбачено новою редакцією Політики конфіденційності.</p>
            <p className={styles.description}>9.3. Усі пропозиції або питання щодо цієї Політики конфіденційності слід
              повідомляти в розділ "КОНТАКТИ".</p>
          </div>
        </div>

        <div className={styles.modalPrivacyPolicy_content_buttons}>
          <CustomCheckbox
            handleCheckboxChange={handleCheckboxChange}
            isChecked={isChecked}
            text={'Натискаючи кнопку Прийняти, я погоджуюсь що ознайомлений з\n' +
              '                            Правилами та умовами надання послуг і\n' +
              '                            підтверджую згоду на обробку персональних даних.'}
            id={1}
            borderColor={"#405BD8"}
          />


          <div style={{alignSelf: 'flex-end'}}>
            <MainButtonWithBackground
              onClick={handleNavigate}
              text={'Прийняти'}
              type={'button'} // button, submit, reset
              width={windowWidth > 768 ? 'auto' : '100%'}
              condition={!isChecked} // is button disabled
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalPrivacyPolicy;
